module.exports = __webpack_public_path__ + "static/media/mount-promise.1871f128.jpg";